var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-table-msgrs-col"},[(_vm.row.getMsgrs().length)?_c('msgrs-list',{attrs:{"msgrs":_vm.row.getMsgrs(),"scope":_vm.row}}):_c('span',[_vm._v("-")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }